module.exports = __webpack_public_path__ + "static/media/app-store.5986b92f.png";